import {
  NotificationAddedSubscription,
  NotificationAddedSubscriptionDocument,
} from './NotificationAddedSubscription.generated';
import ALLOWED_TYPES from '../../../helpers/ALLOWED_TYPES';
import LOYALTY_TYPES from '../../../helpers/LOYALTY_TYPES';
import getNotificationType from '../../queries/getPendingNotifications/helpers/getNotificationType';

const SIX_HOURS = 3_600_000;

const onNormalNotificationAdded: WorkerSubscription = (args) => {
  const { client, addToQueue, context } = args;
  client
    .request({
      query: NotificationAddedSubscriptionDocument,
      variables: { input: { isModal: false } },
    })
    .subscribe({
      error: console.error,
      next: (value) => {
        const data = value.data as Maybe<NotificationAddedSubscription>;
        const node =
          data?.casinoNotificationNormalNotificationAdded?.addedNotification
            ?.node;
        if (node?.type && ALLOWED_TYPES.includes(node.type)) {
          if (
            node.isRead ||
            (LOYALTY_TYPES.includes(node.type) &&
              !context.featureFlags.get('loyalty') &&
              !context.featureFlags.get('isLoyaltyEnabled'))
          ) {
            return;
          }
          addToQueue({
            data: node,
            priority: 'normal',
            type: getNotificationType(node.type),
            dismissStrategy: LOYALTY_TYPES.includes(node.type)
              ? { storage: 'cookie', ttl: SIX_HOURS }
              : undefined,
          });
        }
      },
    });
};

export default onNormalNotificationAdded;
